// frontend/src/ClubSalesHistory/apiClient.js — thin wrapper around authenticatedFetch for /api/club-sales-history (same shape as GiftCards/apiClient.js).
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/club-sales-history';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const get = (path) => authenticatedFetch(`${BASE}${path}`).then(jsonOrThrow);
const post = (path) => authenticatedFetch(`${BASE}${path}`, { method: 'POST' }).then(jsonOrThrow);

export const cshApi = {
  games: (team, season) => get(`/${team}/games${season ? `?season=${season}` : ''}`),
  game: (team, date) => get(`/${team}/games/${date}`),
  preview: (team, date) => get(`/${team}/games/${date}/orders?limit=10`),
  refresh: (team, date) => post(`/${team}/games/${date}/refresh`),
  csv: async (team, date) => {
    const r = await authenticatedFetch(`${BASE}/${team}/games/${date}/orders.csv`);
    if (!r.ok) await jsonOrThrow(r);
    const name = (/filename="([^"]+)"/.exec(r.headers.get('Content-Disposition') || '') || [])[1] || `${team}_${date}_orders.csv`;
    return { blob: await r.blob(), name };
  },
};

export function download({ blob, name }) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
